import { LAYBY } from 'components/orders/constants'

export default function canAdjustOrder(order) {
  // We only allow adjustments for layby orders for now
  return order.orderType === LAYBY
}